export const directorioPageSize = 10;

export const getModelTemporizador = () => ({
    segundo: 0,
    minuto: 0,
    hora: 0,
});

export const getFormDiagnostico = () => ({
    txtCCPeso: {
        label: "Peso:",
        value: "",
    },
    txtCCAltura: {
        label: "Altura:",
        value: "",
    },
    txtCCAlergias: {
        label: "Alergias:",
        value: "",
    },
    txtCCSintomas: {
        label: "Síntomas:",
        value: "",
    },
    txtCCDiagnostico: {
        label: "Diagnóstico:",
        value: "",
    },
    txtCCTratamiento: {
        label: "Tratamiento:",
        value: "",
    },
    txtCCComentarios: {
        label: "Comentarios:",
        value: "",
    },
});

export const getFormBuscarFolio = () => ({
    txtBuscarFolio: {
        label: "Folio del paciente:",
        label2: "Correo de usuario:",
        required: true,
        value: "",
        error: false,
        message: "Ingrese un folio para iniciar la búsqueda",
    },
    txtTipoBusqueda: {
        label: "Seleccionar tipo de búsqueda por folio o correo de usuario:",
        required: true,
        value: "1",
    },
    txtBuscarNombrePaciente: {
        label: "Nombre del paciente:",
        value: "",
    },
    txtBuscarTelefonoPaciente: {
        label: "Teléfono del paciente:",
        value: "",
    },
    txtBuscarCorreoPaciente: {
        label: "Correo del paciente:",
        value: "",
    },
});

export const getFormPaciente = () => ({
    txtCCFolio: {
        label: "Usuario Meditoc:",
        required: true,
        value: "",
        error: false,
        message: "El folio del paciente es requerido",
    },
    txtCCNombre: {
        label: "Nombre del paciente:",
        required: true,
        value: "",
        error: false,
        message: "El nombre del paciente es requerido",
    },
    txtCCTelefono: {
        label: "Teléfono del paciente:",
        required: true,
        value: "",
        error: false,
        message: "Ingrese un número de teléfono válido",
    },
    txtCCCorreo: {
        label: "Correo del paciente:",
        required: true,
        value: "",
        error: false,
        message: "Ingrese un correo electrónico válido",
    },
    txtCCFechaNacimiento: {
        label: "Fecha de nacimiento:",
        required: false,
        value: null,
        error: false,
        message: "Ingrese la fecha de nacimiento",
    },
    txtCCTipoSangre: {
        label: "Tipo de sangre:",
        required: false,
        value: null,
        error: false,
        message: "Seleccione el tipo de sangre",
    },
    txtCCSexo: {
        label: "Sexo:",
        required: false,
        value: null,
        error: false,
        message: "Seleccione el sexo del paciente",
    },
});

export const getHistorialClinicoColumns = () => [
    { title: "ID", field: "iIdHistorialClinico" },
    { title: "Fecha", field: "sFechaCreacion" },
    { title: "Duración", field: "sDuracionConsulta" },
];
